import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'

function Dashboard(){
    return (
        <div>Dashboard</div>
    )
}
export default Dashboard
